(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sss-scoop-hero"] && !Shopify.designMode) return;
  try {
    (()=>{const init=()=>document.querySelectorAll('.sss-scoop-hero:not([data-ready])').forEach(root=>{root.dataset.ready='true';const v=root.querySelector('video'),b=root.querySelector('button');v.muted=true;v.defaultMuted=true;const play=()=>v.play().catch(()=>{});b.addEventListener('click',()=>v.paused?play():v.pause());v.addEventListener('play',()=>{b.textContent='Pause';b.setAttribute('aria-label','Pause video')});v.addEventListener('pause',()=>{b.textContent='Play';b.setAttribute('aria-label','Play video')});play()});init();document.addEventListener('shopify:section:load',init)})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sss-scoop-shipping-offer"] && !Shopify.designMode) return;
  try {
    (()=>{const expired=el=>Date.now()>=Date.parse(el.dataset.sssShippingExpiry);const update=()=>document.querySelectorAll('[data-sss-shipping-expiry]').forEach(el=>{el.hidden=expired(el)});update();setInterval(update,30000);document.addEventListener('click',event=>{const offer=event.target.closest('[data-sss-shipping-expiry]');if(offer&&expired(offer)){event.preventDefault();offer.hidden=true;}});document.addEventListener('shopify:section:load',update);})();
  } catch(e) { console.error(e); }
})();

})();
